import { apiProxyRequest } from "Api/apiProxyRequest";

import type { AllowanceDiscounts } from "Reducers/discount";

export const getAllowanceDiscountsRequest = () =>
  apiProxyRequest<AllowanceDiscounts>(`/discounts/types/allowance`);
